import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { PB_TYPE_IMAGE, PB_TYPE_CAROUSEL, PB_TYPE_BANNER } from './constants';
function checkIfHasLightboxAndImages(component) {
  const isImage = [PB_TYPE_IMAGE, PB_TYPE_CAROUSEL].includes(component.type);
  const hasEnabledLightbox = isImage && component.settings.enableLightbox;
  const hasEmptyImage = component.type === PB_TYPE_IMAGE && !component.settings.imageId;
  return hasEnabledLightbox && !hasEmptyImage;
}
function getLightboxImages(pageBuilder) {
  const getImage = component => {
    const hasLighboxAndImage = checkIfHasLightboxAndImages(component);
    if (hasLighboxAndImage) {
      if (component.type === PB_TYPE_CAROUSEL) {
        const hasBanner = !!isOnlyChildBanner(component.type, component.items);
        return component.settings.imageIds.map((imageId, index) => {
          const currentElement = _objectSpread(_objectSpread({}, component.settings), {}, {
            imageId,
            hasBanner,
            banner: hasBanner ? component.items[0].settings : null
          });
          delete currentElement.imageIds;
          return currentElement;
        });
      }
      return isOnlyChildBanner(component.type, component.items) ? [_objectSpread(_objectSpread({}, component.settings), {}, {
        hasBanner: true,
        banner: component.items[0].settings
      })] : [component.settings];
    }
    return [];
  };
  const isOnlyChildBanner = (type, items) => [PB_TYPE_IMAGE, PB_TYPE_CAROUSEL].includes(type) && items && items.length === 1 && items[0].type === PB_TYPE_BANNER;
  const getItems = component => !component.items || !component.items.length || isOnlyChildBanner(component.type, component.items) ? getImage(component) : component.items.map(child => getItems(child));
  const parseImages = container => Array.isArray(container) ? [].concat(...container.map(parseImages)) : container;
  return parseImages(pageBuilder.map(component => getItems(component)));
}
export default getLightboxImages;
//# sourceMappingURL=get-lightbox-images.js.map